import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Colors } from '@pinchenterprisesnpm/friday-ui'

export const FloatingLabel = styled.label<{
  hasValue: boolean
  isFocused: boolean
}>`
  position: absolute;
  left: 38px;
  top: ${(props) => (props.hasValue ? '4px' : '14px')};
  transition: all 0.2s ease;
  font-size: ${(props) => (props.hasValue ? '12px' : '14px')};
  color: #868686;
  padding: 0 4px;
  pointer-events: none;
  z-index: 2;
  line-height: 1;
  font-weight: 400;
`

export const TriggerContainer = styled.div<{
  isFocused?: boolean
  hasError?: boolean
  isDisabled?: boolean
  customWidth?: string
}>`
  position: relative;
  display: flex;
  align-items: center;
  height: 42px;
  border: 1px solid
    ${(props) => (props.hasError ? Colors.danger : props.isFocused ? Colors.primary : '#d8d8d8')};
  border-radius: 4px;
  padding: 8px 14px;
  width: ${({ customWidth }) => customWidth || '100%'};
  cursor: pointer;
  transition: border-color 0.2s ease;
  background: ${({ isDisabled }) => (isDisabled ? Colors.disabled : 'white')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
`

export const TriggerContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const DateText = styled.span`
  padding-top: 16px;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  flex: 1;
`

export const LeftIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #868686;
  margin-right: 12px;
  align-self: center;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #868686;
  margin-left: 8px;
`

export const StyledIcon = styled(FontAwesomeIcon)`
  height: 16px;
  width: 16px;
  color: #c5c5c7;
`
